var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.86 81.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .h {\n        fill: url(#e);\n      }\n\n      .h, .i, .j, .k, .l {\n        stroke-width: 0px;\n      }\n\n      .i {\n        fill: url(#g);\n      }\n\n      .j {\n        fill: #fff;\n      }\n\n      .k {\n        fill: url(#d);\n      }\n\n      .l {\n        fill: url(#f);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -2251.9,
    y1: 1423.63,
    x2: -2167.59,
    y2: 1423.63,
    gradientTransform: "translate(-2528.25 -514.94) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#444445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#545455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6e6e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#929293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f2f2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    "data-name": "New Gradient Swatch copy",
    x1: 5349.5,
    y1: 6981.29,
    x2: 5349.5,
    y2: 7078.71,
    gradientTransform: "translate(-8709.13 -1143.79) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f2f2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#929293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6e6e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#545455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#444445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -2240.63,
    y1: 1392.74,
    x2: -2175.43,
    y2: 1457.94,
    gradientTransform: "translate(-2528.25 -514.94) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5e5e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e9eaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cfd0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#aeb0b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -2227.24,
    y1: 1423.63,
    x2: -2184.28,
    y2: 1423.63,
    gradientTransform: "translate(-2528.25 -514.94) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#717274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afafb1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m9.55,13.84L.21,48.7c-.56,2.09.04,4.33,1.57,5.86l25.52,25.52c1.53,1.53,3.76,2.13,5.86,1.57l34.86-9.34c2.09-.56,3.73-2.2,4.29-4.29l9.34-34.86c.56-2.09-.04-4.33-1.57-5.86L54.56,1.78c-1.53-1.53-3.77-2.13-5.86-1.57L13.84,9.55c-2.09.56-3.73,2.2-4.29,4.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m65.01,16.84c11.26,11.26,12.98,28.5,5.15,41.58-.18.31-.38.62-.57.93-1.29,2.01-2.81,3.92-4.57,5.67-1.76,1.76-3.66,3.28-5.67,4.57-.31.2-.62.39-.93.57-13.08,7.83-30.32,6.12-41.58-5.15S3.86,36.51,11.7,23.44c.18-.31.38-.62.57-.93,1.29-2.01,2.81-3.92,4.57-5.67,1.76-1.76,3.66-3.28,5.67-4.57.31-.19.62-.39.93-.57,13.08-7.83,30.32-6.12,41.58,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m64.41,17.44c10.88,10.88,12.62,27.49,5.23,40.2-.18.32-.38.64-.58.95-1.29,2.08-2.84,4.03-4.64,5.83s-3.75,3.35-5.83,4.64c-.32.21-.64.4-.95.58-12.72,7.4-29.32,5.65-40.2-5.23-10.88-10.88-12.62-27.48-5.22-40.19.19-.32.38-.64.58-.95,1.29-2.08,2.84-4.03,4.64-5.83,1.8-1.8,3.75-3.35,5.83-4.64.32-.21.64-.4.95-.58,12.71-7.39,29.31-5.66,40.19,5.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m58.72,23.14c1.28,1.28,2.42,2.7,3.38,4.19l.65,1.02-12.58,12.58,12.58,12.58-.65,1.02c-.96,1.5-2.09,2.91-3.38,4.19-1.28,1.28-2.69,2.42-4.19,3.38l-1.02.65-12.58-12.58-12.58,12.58-1.02-.65c-1.5-.96-2.91-2.09-4.19-3.38s-2.42-2.7-3.38-4.19l-.65-1.02,12.58-12.58-12.58-12.58.65-1.02c.96-1.5,2.09-2.91,3.38-4.19,1.29-1.29,2.7-2.42,4.19-3.38l1.02-.65,12.58,12.58,12.58-12.58,1.02.65c1.5.96,2.91,2.09,4.19,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m24.2,24.21c-1.22,1.22-2.28,2.54-3.17,3.94l12.79,12.79-12.79,12.79c.89,1.4,1.95,2.72,3.17,3.94s2.54,2.28,3.94,3.17l12.79-12.79,12.79,12.79c1.4-.89,2.72-1.95,3.94-3.17,1.22-1.22,2.28-2.54,3.17-3.94l-12.79-12.79,12.79-12.79c-.89-1.4-1.95-2.72-3.17-3.94-1.22-1.22-2.54-2.28-3.94-3.17l-12.79,12.79-12.79-12.79c-1.4.89-2.72,1.95-3.94,3.17Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.0f165df909e1cd31ebccc1eaa838a57e.svg";
export { ForwardRef as ReactComponent };